<template>
	<v-img
			v-bind="$attrs"
			:alt="imageAlt"
			:lazy-src="placeholderImage"
			:src="imageURL"
	></v-img>
</template>

<script>
import { resizeCloudinaryImage } from '../../../helpers';

export default {
	name: 'HeroImage',
	props: {
		pass: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			placeholderImage: "https://placehold.co/640x320",
		};
	},
	computed: {
		imageURL() {
			return this.getImageURL("Hero");
		},
		imageAlt() {
			const media = this.findMedia("Hero");
			return media ? media.alt : "Placeholder Image";
		},
	},
	methods: {
		findMedia(type) {
			return this.pass.media.find((mediaItem) => mediaItem.location === type);
		},
		getImageURL(type) {
			const media = this.findMedia(type);
			if(media && media.url) {
				return resizeCloudinaryImage(media.url, 640, 320);
			}
			return this.placeholderImage;
		}
	},
};
</script>
